/**
 * Convenience method to wrap a CSS variable in `var()`,
 * e.g. `cssVar('--coreui-gridList-itemWidth')` => `var(--coreui-gridList-itemWidth)`.
 */
type CSSVar = (cssVariableName: string) => string;
export const cssVar: CSSVar = (cssVariableName) => `var(${cssVariableName})`;

/**
 * Convenience method to append a value with 'px' only if the value is a number, otherwise returns the original value.
 * @example `px(10)` => `10px`, `px('10%')` => `10%`, px(undefined) => undefined
 */
export const px = (cssLengthValue: number | string | undefined): string | undefined =>
  typeof cssLengthValue === 'number' ? `${cssLengthValue}px` : cssLengthValue;
